import {
    apiGetClient,
    apiPostClient,
    apiPutClient,
} from "../../api/apiSvtAdmin";

import { toast } from "react-toastify";
import i18n from "i18next";
const t = i18n.t.bind(i18n);

/**
 * Fetch all administrator users
 */
export const getAllAdminList = async () => {
    try {
        const response = await apiGetClient.get("foundation/users/admin");
        return response.data;
    } catch (error) {
        toast.error(
            error.response?.data?.error || "Failed to fetch administrators.",
            { position: "top-center" }
        );
        return null;
    }
};

/**
 * Create a new administrator
 * @param {Object} data - { email, firstName, lastName, comments }
 */
export const createNewAdmin = async (data) => {
    try {
        const response = await apiPostClient.post(
            "foundation/users/admin",
            data
        );
        if (response?.data?.data) {
            toast.success(t("adminAddedSuccess", { email: data.email }), {
                position: "top-center",
            });
            return response.data;
        } else {
            toast.error(t("unexpectedServerResponse"), {
                position: "top-center",
            });
            return null;
        }
    } catch (error) {
        const errorData = error.response?.data;
        if (errorData?.errors) {
            Object.keys(errorData.errors).forEach((field) => {
                errorData.errors[field].forEach((message) => {
                    toast.error(message, { position: "top-center" });
                });
            });
        } else {
            toast.error(error.response?.data?.error, { position: "top-center" });
        }
        return null;
    }
};

/**
 * Update an existing administrator
 * @param {Object} data - Updated fields: { email, firstName, lastName, comments }
 * @param {string} userId - ID of the user to update
 */
export const updateAdmin = async (data, userId) => {
    try {
        const response = await apiPutClient.put(
            `foundation/users/${userId}`,
            data
        );
        toast.success(t("adminUpdatedSuccess", { emailId: data.email }), {
            position: "top-center",
        });
        return response.data;
    } catch (error) {
        const errorData = error.response?.data;
        if (errorData?.errors) {
            Object.keys(errorData.errors).forEach((field) => {
                errorData.errors[field].forEach((message) => {
                    toast.error(message, { position: "top-center" });
                });
            });
        } else {
            toast.error(
                error.response?.data?.error || t("failedToUpdateAdmin", { email: data.email }),
                { position: "top-center" }
            );
        }
        return null;
    }
};

/**
 * Revoke an administrator
 * @param {string} userId - ID of the user to revoke
 *  @param {string} email - Email of the user to display in the message
 */
export const revokeAdmin = async (userId, email) => {
    try {
        const response = await apiPutClient.put(
            `/foundation/users/${userId}/revoke`
        );
        toast.success(t("adminRevokedSuccess", { email }), {
            position: "top-center",
        });
        return response.data;
    } catch (error) {
        const errorData = error.response?.data;
        if (errorData?.errors) {
            Object.keys(errorData.errors).forEach((field) => {
                errorData.errors[field].forEach((message) => {
                    toast.error(message, { position: "top-center" });
                });
            });
        } else {
            toast.error(errorData?.error || "Error revoking admin.", {
                position: "top-center",
            });
        }
        return null;
    }
};
